import { loader } from "../utils/assetLoader";
import { settings, returnPlatformType, zone01, zone02, zone03, finalZone, tutorial01, tutorial02, playground } from "./config";
import Cosmetics from "./elements/Cosmetics";

let tutorials = [tutorial01, tutorial02, playground];
// let zones = [zone02, zone03, finalZone];  // For testing purposes
let zones = [zone01, zone02, zone03, finalZone];
class LevelBuilder {
    constructor(app, engine, config) {
        this.app = app;
        this.engine = engine;
        this.config = config;

        this.Builder = new Builder(this.engine, this.app, this.config);
    }

    // ---------------------------------------------
    // ---------------- [ Cosmetics Creation ] -----
    /**
     * We have to do this first because of render order
     * It's very messy but essentially we take the data of the platforms 
     * that would be there to add the plants and rocks
     */
    createCosmetics() {
        let levelWidth = 0;
        zones.forEach((zone, i) => {
            let zoneData = new Cosmetics(this.engine, this.app, this.config, zone, levelWidth).create();
            levelWidth += zoneData.levelWidth;
        })

        return levelWidth;
    }

    
    // -----------------------------------------
    // ---------------- [ Level Creation ] -----
    tutorialLength() {
        return tutorials.length;
    }
    
    createTutorial(index) {
        let zoneData = this.Builder.createPlatform(tutorials[index], 0);
        let gameObjects = zoneData.gameObjects;
        let hazards = zoneData.hazards;
        let pickups = zoneData.pickups;
        let systems = zoneData.systems;
        let levelWidth = zoneData.levelWidth;

        return {
            gameObjects,
            hazards,
            systems,
            pickups,
            levelWidth,
        }
    }

    createLevel() {
        let gameObjects = [], hazards = [], pickups = [], systems = [],
            levelWidth = 0;

        zones.forEach((zone, i) => {
            let zoneData = this.Builder.createPlatform(zone, levelWidth);

            gameObjects = gameObjects.concat(zoneData.gameObjects);
            hazards = hazards.concat(zoneData.hazards);
            pickups = pickups.concat(zoneData.pickups);
            systems = systems.concat(zoneData.systems);
            levelWidth = zoneData.levelWidth;
        })

        return {
            gameObjects,
            hazards,
            systems,
            pickups,
        }
    }

    cleanupLevel(gameObjects, hazards, pickups) {
        // Remove all objects from the world and stage
        for (const obj of gameObjects) {
            if (obj.container) {
                this.app.stage.removeChild(obj.container);
            }
            if (obj.body) {
                Matter.Composite.remove(this.engine.world, obj.body);
            }
        }

        if(pickups.length > 0) {
            for (const obj of pickups) {
                if(obj.tile || obj.body) obj.destroy();
            }
        }
    }
}

export default LevelBuilder;

import PlatformMaker from "./elements/PlatformMaker";
class Builder {
    constructor(engine, app, config) {
        this.engine = engine;
        this.app = app;
        this.config = config;

        this.PlatformMaker = new PlatformMaker(engine, app);
    }

    // -----------------------------------------------------------------------
    // --------------------------------- [ Analysing the full matrix ] -----
    createPlatform(levelLayout, prevLength = 0) {
        let gameObjects = [], hazards = [], pickups = [], systems = [];
        const groundY = this.config.height - settings.groundHeight;
        let xTotal = prevLength;
        
        // Create level elements based on the layout
        for (const platform of levelLayout) {
            if(platform.name == "gap") {
                xTotal += settings.gapWidth;
            } else {
                let gameObject, pickupData, systemData;
                
                if(!platform.force) {
                    [gameObject, pickupData, systemData] = this.PlatformMaker.make(platform, xTotal, groundY - platform.height);
                    xTotal += gameObject.width;
                } else {
                    let xPos = platform.force.relative ? 
                        platform.force.x + xTotal: 
                        platform.force.x + prevLength;
                    
                    [gameObject, pickupData, systemData] = this.PlatformMaker.make(platform, xPos, groundY - platform.height);
                }
                
                pickups = pickups.concat(pickupData);
                systems = systems.concat(systemData);
                gameObjects.push(gameObject);
                if(gameObject.type === "hazard") 
                    hazards.push(gameObject);
            }
        }

        
        return {
            gameObjects: gameObjects,
            hazards: hazards,
            pickups: pickups,
            systems: systems,
            levelWidth: xTotal,
        };
    }

}